import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';

import ContentEdit, { Actions, Header, Detail, Side } from './ContentEdit';
import {
  ReceiptsFilter,
  ReceiptsCardsSide,
  ReceiptsCards,
  ReceiptDialog,
  ReceiptDialog2,
} from './Receipts';
import {
  ClientCards,
  ClientDialog,
  ClientsFilter,
} from './Clients';

const styles = theme => ({
  root: {
    marginTop: theme.spacing.unit,
    marginRight: theme.spacing.unit*4,
    marginBottom: theme.spacing.unit*4,
    marginLeft: theme.spacing.unit*4,
  },
});

class ClientsPage extends Component {
  constructor(props){
    super(props);

    this.state = {
      showDialog: false,
      dialogType: undefined,
      client: undefined,
    };
  }

  render() {
    const { classes, theme } = this.props;
    const { showDialog, dialogType, client } = this.state;
    return(
      <div className={classes.root}>
        {showDialog &&
          <ClientDialog
            show={showDialog}
            type={dialogType}
            clientData={client}
            handleClose={() => this.setState({showDialog: false, dialogType: undefined, client: undefined})}
          />
        }
        <ContentEdit>
          <Header theme={theme}>
            <ClientsFilter handleAdd={() => this.setState({showDialog: true, dialogType: "add", client: undefined})} />
          </Header>
          <Detail theme={theme}>
            <ClientCards
              handleEdit={(client) => {
                this.setState({showDialog: true, dialogType: "edit", client: client})}
              }/>
          </Detail>
        </ContentEdit>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(ClientsPage);



// WEBPACK FOOTER //
// ./src/components/admin/ClientsPage.jsx